/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does this calculator support a step-up SIP (increasing contributions each year)?`)
};

const es_sip_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Esta calculadora admite un SIP escalonado (aumentar contribuciones cada año)?`)
};

const de_sip_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstützt dieser Rechner ein Schritt-SIP (steigende Beiträge jedes Jahr)?`)
};

const nl_sip_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ondersteunt deze calculator een step-up SIP (jaarlijks toenemende bijdragen)?`)
};

const fr_sip_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce calculateur supporte-t-il un SIP progressif (augmentation des cotisations chaque année) ?`)
};

const it_sip_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo calcolatore supporta un SIP con aumento graduale (aumento dei contributi ogni anno)?`)
};

const pt_br2_sip_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta calculadora suporta um SIP escalonado (aumentando contribuições a cada ano)?`)
};

const pt_sip_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta calculadora suporta um SIP de aumento escalonado (aumentar contribuições cada ano)?`)
};

const ja_sip_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この計算機はステップアップSIP（毎年の投資額増加）に対応していますか？`)
};

const zh_sip_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此计算器是否支持阶梯式SIP（逐年增加投资额）？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_hub_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_hub_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_hub_faq4_q", locale)
	if (locale === "en") return en_sip_hub_faq4_q(inputs)
	if (locale === "es") return es_sip_hub_faq4_q(inputs)
	if (locale === "de") return de_sip_hub_faq4_q(inputs)
	if (locale === "nl") return nl_sip_hub_faq4_q(inputs)
	if (locale === "fr") return fr_sip_hub_faq4_q(inputs)
	if (locale === "it") return it_sip_hub_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_sip_hub_faq4_q(inputs)
	if (locale === "pt") return pt_sip_hub_faq4_q(inputs)
	if (locale === "ja") return ja_sip_hub_faq4_q(inputs)
	return zh_sip_hub_faq4_q(inputs)
};